import { render, staticRenderFns } from "./RiepilogoNc.vue?vue&type=template&id=8def7d4c&scoped=true"
import script from "./RiepilogoNc.vue?vue&type=script&lang=js"
export * from "./RiepilogoNc.vue?vue&type=script&lang=js"
import style0 from "./RiepilogoNc.vue?vue&type=style&index=0&id=8def7d4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8def7d4c",
  null
  
)

export default component.exports